export default __webpack_public_path__ + "static/media/vsphere.47e12122.svg";